;( function ($, window, document, undefined) {
    'use strict';

    const getTop = () => jQuery(window).scrollTop();

    const body = $('body');
    const $site_navbar = $('.site-navbar');

    const is_desktop_view = () => window.innerWidth >= 1200;

    ;( function () {
        const menu_primary_list = $site_navbar.find('.menu-primary__list');

        const handle_hover = function () { $( this ).toggleClass('-pre-has-hover') };
        menu_primary_list.find('a').
        hover(handle_hover, function () {}).
        on('focusin', handle_hover);
    })();

    ;( function () {

        const $site_slogan = $('#site-slogan');
        const slogan_height = $site_slogan.outerHeight();

        if( is_desktop_view() ) {
            ( getTop() !== 0 ) && $site_navbar.addClass('-pre-navbar-scroll');
        }
        else {
            ( getTop() > slogan_height ) && $site_navbar.addClass('-pre-navbar-scroll');
        }

        const  handle_scroll = (event) => {
            const slogan_height = $site_slogan.outerHeight();
            if( is_desktop_view() ) {
                if (getTop() === 0 ) $site_navbar.removeClass('-pre-navbar-scroll');
                else $site_navbar.addClass('-pre-navbar-scroll');
            }
            else {
                if (  jQuery(window).scrollTop() > slogan_height ) $site_navbar.addClass('-pre-navbar-scroll');
                else $site_navbar.removeClass('-pre-navbar-scroll');
            }
        };
        $(window).on('scroll', handle_scroll );

    })();

    ;( function () {
        const $navbar_slide             = $site_navbar.find('.site-navbar__slide');
        const $search_form              = $navbar_slide.find('.site-navbar__search-form');
        const $search_label             = $search_form.find('label');
        const $recent_toughts           = $site_navbar.find('.recent-toughts');
        const $recent_toughts_subtitle  = $recent_toughts.find('.recent-toughts__subtitle');
        const $recent_toughts_list      = $recent_toughts.find('.recent-toughts__list');

        const get_search_input = () => $search_form.find('[type="search"]');

        const $search_input             = get_search_input();

        const handle_menu_open = type => $site_navbar.addClass('menu-open').attr('menu-open', type) ;

        ;( _ => $site_navbar.find('.site-navbar__button, .site-navbar__slide-close').on('click', e => e.preventDefault() ) )();

        $site_navbar.find(`.site-navbar__button.-pre-button-newsletter`).on('click', () => $('#newsletter_form_modal').modal('show') );

        ;( function () {

            const items = [
                {
                    current: '.menu-primary',
                    show: '.recent-toughts',
                    open: 'search',
                    child: 'first'
                },
                {
                    current: '.recent-toughts',
                    show: '.menu-primary',
                    open: 'menu',
                    child: 'last'
                }
            ];

            const handle_animation = function(item) {
                const $li = $(this);
                const $menu_primary_list = $li.parent();
                if( $menu_primary_list.hasClass('-pre-sepecial-fade-out') && !$menu_primary_list.hasClass('-pre-fade-out-close') ) {
                    $navbar_slide.find(item.current).hide().find(`${item.current}__list`).removeClass('-pre-sepecial-fade-out');
                    $navbar_slide.find(item.show).show().find(`${item.show}__list`).addClass('-pre-sepecial-fade-in');
                    handle_menu_open(item.open);
                }
            };

            items.map( item => body.on(
                'animationend webkitAnimationEnd',
                `${item.current} li:${item.child}-child`,
                function () {
                    handle_animation.call(this, item)
                }
            ));
        })();

        const handle_navbar_button_press = function ( event, type ) {

            const key_code = event.keyCode || event.which;

            const _is_type = ( _type ) => type === _type;

            const $menu_primary = $navbar_slide.find('.menu-primary');
            const $menu_primary_list = $menu_primary.find(`.menu-primary__list`);

            // Nullify classes and animtions
            $navbar_slide.find('.-pre-fade-out-close').removeClass('-pre-fade-out-close');
            $navbar_slide.find('.-pre-sepecial-fade-out').removeClass('-pre-sepecial-fade-out');
            //$menu_primary_list.removeClass('-pre-sepecial-fade-out');
            $navbar_slide.find('.menu-primary').hide();
            $navbar_slide.find('.recent-toughts').hide();

            $menu_primary.show()

            // If the user open the menu only
            if( _is_type( 'menu' ) ) {
                $menu_primary_list.addClass('-pre-sepecial-fade-in')
            }

            handle_menu_open(type);

            if( _is_type( 'menu' ) ) {
                setTimeout( _ => $menu_primary_list.children().first().find('> a').focus() , 100 );
            }

            // If the user open the search run on 'focusin' trigger
            if( _is_type( 'search' ) ) {
                const e = jQuery.Event( 'mouseup', { keyCode: 1 } );
                $search_input.trigger( e );
                window.setTimeout( _ => $search_input.focus(), 100 );
            }
        };

        ['menu', 'search', 'language'].map( type => {
            $site_navbar.find(`.site-navbar__button.-pre-button-${type}`)
                .on('click',
                    function(event) {
                        const _this = this;
                        event.preventDefault();
                        is_desktop_view() && $navbar_slide.show();
                        window.setTimeout( () => handle_navbar_button_press.call( _this, event, type ), 0 );
                    }
                )
        });

        const handle_slide_close_accessibility = function( event ) {
            if ( !$site_navbar.is(event.target) // if the target of the click isn't the container...
                && $site_navbar.has(event.target).length === 0 ) { // ... nor a descendant of the container
                setTimeout( _ => $('.site-navbar__slide-close').trigger('click'), 0 )
            }
        };

        // Close menu if clicked outside of the menu container
        $(document).on('keyup mouseup', function (event) {
            let key_code = event.keyCode || event.which;
            key_code = parseInt( key_code );
            if( ( key_code === 1 || key_code === 9 ) && is_desktop_view()  )
                handle_slide_close_accessibility.call( this, event );
        });

        // The user would like to close the menu
        $site_navbar.find('.site-navbar__slide-close').on('click', _ => {
            const type = $site_navbar.attr('menu-open');
            const current_tupe = type === 'menu' ? '.menu-primary' : '.recent-toughts';
            $navbar_slide.find(current_tupe).find(`${current_tupe}__list`).addClass('-pre-sepecial-fade-out -pre-fade-out-close');
            $search_label.text( $search_label.data('focusout_text') );
            $site_navbar.removeClass('menu-open');
            is_desktop_view() && setTimeout( _=> $navbar_slide.hide(), 550 );
        });


        // Search form handling
        {
            // Disabled search form submit if no value in the search field
            //$search_form.on('submit', e => !get_search_input().val().trim().length &&  e.preventDefault() );

            const handle_search_results_show = function(event) {

                const menu_primary   = $navbar_slide.find('.menu-primary');
                const recent_toughts = $navbar_slide.find('.recent-toughts');

                /**
                 * The user can reach to the focusin by 2 ways:
                 *  A. He open the menu and then focusin on the search input in the .site-navbar
                 *  B. He clicked on the search button on the .site-navbar
                 *  ----------------------------------------------------------------------------
                 */

                // If its option A, it means that the .menu-primary element will get an inline style of display:block
                // So we give this element the its fade-out animtion
                if( menu_primary.css('display') === 'block' ) {
                    menu_primary.find('.menu-primary__list').removeClass('-pre-sepecial-fade-in').addClass('-pre-sepecial-fade-out');
                }

                // If its option B, the .recent-toughts wil get an inline style of display:block and we just have to give his list animation
                else {
                    recent_toughts.show().find('.recent-toughts__list').addClass('-pre-sepecial-fade-in');
                }

                $search_label.text( $search_label.data('focusin_text') );
            };

            const handle_search_results_hide = function(event) {
                const current_val = $(this).val().trim();
                if( !current_val.length ) {
                    $navbar_slide.find('.recent-toughts__list')
                        .removeClass('-pre-sepecial-fade-in')
                        .addClass('-pre-sepecial-fade-out');
                    $search_label.text( $search_label.data('focusout_text') );
                }
            };

            $(document).on('mouseup', function (event) {

                if( ! is_desktop_view() ) return;

                const element = event.target;

                const key_code = event.which || event.keyCode;

                if( parseInt( key_code ) === 1 ) {
                    if( Boolean(element.id) ) {
                        if( element.parentNode.classList.contains('site-navbar__search-form') ) {
                            handle_search_results_show.call( this, event );
                        }
                    }
                    else {
                        handle_search_results_hide.call( this, event );
                    }
                }
            });

            $search_input.on('focusin', function (e) {

                if( is_desktop_view() ) return;

                handle_search_results_show.call( this, e );

            });

            $search_input.on('blur', function (e) {

                if( is_desktop_view() ) return;

                handle_search_results_hide.call(this, e);
            });

            $search_form.find('[type="button"]').on('click', function (e) {
                e.preventDefault();
                $search_input.val('');
                $search_label.text( $search_label.data('focusout_text') ).show();
                setTimeout( _ => {
                    $navbar_slide.find('.recent-toughts__list')
                        .removeClass('-pre-sepecial-fade-in')
                        .addClass('-pre-sepecial-fade-out');
                }, 1);
            });

            $search_input.on('keyup', function (e) {
                const $this         = $(this);
                const current_val   = $this.val().trim();
                $search_label.show();
                current_val.length && $search_label.hide();
                clearTimeout( $.data(this, 'timer') );
                $this.data(
                    'timer',
                    setTimeout( pearlcohen_handle_search_service.bind($this, $recent_toughts_list, $recent_toughts_subtitle), 500)
                );
            });
        }
    })();
})(jQuery, window, document);